import * as React from 'react'

// components
import Svg from './..'

const BudgetRightArrow = props => {
  return (
    <Svg width='1em' height='1em' viewBox='0 0 12 12' {...props}>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M6 0c3.31 0 6 2.69 6 6s-2.69 6-6 6-6-2.69-6-6 2.69-6 6-6zm-.036 10.25L10.214 6l-4.25-4.25L4.75 2.964l2.179 2.179H1.714v1.714H6.93L4.75 9.036l1.214 1.214z'
        fill='currentColor'
      />
    </Svg>
  )
}

export default BudgetRightArrow
